class Local {
  /* user */
  public setAuthToken (id: string) {
    localStorage.setItem('authToken', id)
  }
  public getAuthToken () {
    return localStorage.getItem('authToken')
  }

  public setUserId (id: string) {
    localStorage.setItem('userId', id)
  }
  public getUserId () {
    return localStorage.getItem('userId')
  }

  public setCompanyId (id: string) {
    localStorage.setItem('companyId', id)
  }
  public getCompanyId () {
    return localStorage.getItem('companyId')
  }

  public setUserName (name: string) {
    localStorage.setItem('userName', name)
  }
  public getUserName () {
    return localStorage.getItem('userName')
  }

  public setUserType (type: string) {
    localStorage.setItem('userType', type)
  }
  public getUserType () {
    return localStorage.getItem('userType')
  }

  // システム定義
  public setConstantValue (constantValue: string) {
    localStorage.setItem('constantValue', constantValue)
  }
  public getConstantValue () {
    return localStorage.getItem('constantValue')
  }

  // サービス機能設定
  public setServicdeFunctionValue (serviceFunctionValue: string) {
    localStorage.setItem('serviceFunctionValue', serviceFunctionValue)
  }
  public getServiceFunctionValue () {
    return localStorage.getItem('serviceFunctionValue')
  }

  /* selectbox */
  // 品種セレクトボックスを構成するためのデータ
  public setVarietiesData (varieties: string) {
    localStorage.setItem('varietiesData', varieties)
  }
  public getVarietiesData () {
    return localStorage.getItem('varietiesData')
  }

  // ステータスセレクトボックスを構成するためのデータ
  public setGrowthStageData (growth: string) {
    localStorage.setItem('growthStageData', growth)
  }
  public getGrowthStageData () {
    return localStorage.getItem('growthStageData')
  }

  // リスクセレクトボックスを構成するためのデータ
  public setRiskData (risk: string) {
    localStorage.setItem('riskData', risk)
  }
  public getRiskData () {
    return localStorage.getItem('riskData')
  }

  // グループセレクトボックスを構成するためのデータ
  public setGroupData (group: string) {
    localStorage.setItem('groupData', group)
  }
  public getGroupData () {
    return localStorage.getItem('groupData')
  }

  // 作付け記録詳細
  public setGraphSettingData (data: string, id: string) {
    localStorage.setItem(`graphSetting${id}`, data)
  }
  public getGraphSettingData (id: string) {
    return localStorage.getItem(`graphSetting${id}`)
  }
}
export default new Local()
